import { Routes, Route } from "react-router-dom";
import { Shell } from "@/components/layout";
import { DialogPage } from "@/pages/DialogPage";
import { BrowsePage } from "@/pages/BrowsePage";
import { FeedPage } from "@/pages/FeedPage";
import { PreferencesPage } from "@/pages/PreferencesPage";

export function App() {
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<FeedPage />} />
        <Route path="/about" element={<BrowsePage />} />
        <Route path="/preferences" element={<PreferencesPage />} />
        <Route path="/dialog/:slug" element={<DialogPage />} />
      </Route>
    </Routes>
  );
}
